let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("glWzP"), load("6vzdH"), load("hBh8x"), load("5JvKa"), load("6nLV7"), load("c6MKV"), load("f0OaY")]).then(() => parcelRequire('bkgW7'));